import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styles from "./backToTop.module.css";
import { scrollTop } from './services';
import useTranslation from "next-translate/useTranslation";

var BackToTop = function BackToTop() {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  var isRTL = lang === 'farsi';
  return /*#__PURE__*/_jsx("div", {
    onClick: scrollTop,
    className: styles.backToTop,
    children: isRTL ? 'برگشت به بالا' : 'Back to top'
  });
};

export default BackToTop;